import React, { useEffect, useState } from 'react'
import p_nav_previous from "../../Assets/Images/p_nav_previous.svg";
import { useLocation, useNavigate, useParams } from 'react-router';
import axiosInstance from '../../Services/axios';
import { useSelector } from 'react-redux';
import CenterLoginNavigateModal from '../../Components/modal/centerSmallModal';
import { showToast } from '../../Components/toastConfig/ToastConfig';
import { getVendorProfileDetails } from '../../Services/api';
import NodeaxiosInstance from '../../Services/nodeaxios';

const OfferBooking = () => {
    const navigate = useNavigate();
    const location = useLocation()
    const { vendorId: vendor_id } = useParams();

    const { applyid, offerid, offertype, categoryStatus, offerdetails } = location.state || {};
    const state = useSelector((state) => state);
    const [userData, serUserData] = useState(state?.userAuth?.user);
    const [vendorStatus, setVendorstatus] = useState()
    const [showModal, setShowModal] = useState(false);






    useEffect(() => {
        getvendorStatus()
        localStorage.removeItem('serviceAdded');
        // getcartid()
    }, [])

    const getvendorStatus = () => {
        try {
            let reqData = {
                "vendor_id": vendor_id
            }

            getVendorProfileDetails(reqData)
                .then((res) => {
                    setVendorstatus(res.data.vendor_profile.vendor_details)
                })
        }
        catch (err) {
            if (err.response.status == 400 || err.response.status == 500) {
                showToast(err.response || "Something went wrong, please try again later", "error");
            }
        }
    }
    //vendor_details.vendor_type_name

    const setProductDetails = (shipping_type) => {

        localStorage.removeItem('serviceDetail');
        localStorage.removeItem('serviceAdded');
        localStorage.removeItem('productAdded');
        localStorage.removeItem('localStorageserviceTime');
        localStorage.removeItem("productDeliveryTime");
        localStorage.removeItem("cartid")
        localStorage.removeItem("cart_items")
        localStorage.removeItem('productCart')
        localStorage.removeItem('appliedCard');

        if (offertype == '1' || offertype == '4') {
            let productDetail = {
                'shipping_type': shipping_type,
                'Offerid': offerid,
            }

            let cardDetail = {
                cardStatus: '1',
                cardType: 'offer',
                cardId: offerid,
            }

            let productCart = {
                shipping_type: shipping_type,
                cartId: "",
                vendorId: vendor_id
            }
            let vendortype = {
                vendor_type: vendorStatus?.vendor_type_name
            }
            localStorage.setItem('productCart', JSON.stringify(productCart));
            localStorage.setItem('appliedCard', JSON.stringify(cardDetail));
            localStorage.setItem('shipping_type', JSON.stringify(productDetail));
            localStorage.setItem('vendortype', JSON.stringify(vendortype));

            navigate(`/products/${vendor_id}`, { state: { offer: "offer", cardStatus: '1', cardType: 'offer', cardId: offerid } })
        } else {
            redeemOfferProduct(shipping_type, vendor_id);

        }


    }

    const selectOfferService = async (serviceType) => {

        if (userData?.user_type != "User") {

            setShowModal(true)
        }
        else if (offertype == 1 || offertype == 4) {
            let serviceDetail = {
                serviceType: serviceType,
                vendorId: vendor_id
            }

            let cardDetail = {
                cardStatus: '1',
                cardType: 'offer',
                cardId: offerid,
            }

            localStorage.setItem('serviceDetail', JSON.stringify(serviceDetail));
            localStorage.setItem('appliedCard', JSON.stringify(cardDetail));
            localStorage.setItem('selectedServiceOption', 'service');
            navigate(`/door-step-service/${vendor_id}`, { state: { fromPage: 'offerPage', offertype: offertype } })
        } else {
            try {

                let params = {
                    "vendor_id": vendor_id,
                    "offer_id": offerid,
                    "service_type": serviceType
                }

                const response = await NodeaxiosInstance.post('/service/redeem-offer', params)
                const data = await response?.data;

                if (response?.status === 200) {
                    let serviceDetail = {
                        serviceType: serviceType,
                        vendorId: vendor_id,
                        cart_app_id: data.cart_app_id
                    }

                    let cardDetail = {
                        cardStatus: '1',
                        cardType: 'offer',
                        cardId: offerid,
                    }

                    localStorage.setItem('serviceDetail', JSON.stringify(serviceDetail));
                    localStorage.setItem('appliedCard', JSON.stringify(cardDetail));
                    localStorage.setItem('selectedServiceOption', 'service');
                    navigate(`/door-step-service/${vendor_id}`, { state: { fromPage: 'offerPage', offertype: offertype } })
                }
            } catch (error) {
                console.log(error);
            }
        }
    }

    const redeemOfferProduct = (shipping_type) => {
        try {
            let reqData = {
                "vendor_id": vendor_id,
                "offer_id": offerid,
                "shipping_type": shipping_type
            };


            NodeaxiosInstance.post('product/redeem-offer-without-login', reqData).then((res) => {

                let productDetail = {
                    'shipping_type': shipping_type,
                    'Offerid': offerid,
                }

                let cardDetail = {
                    cardStatus: '1',
                    cardType: 'offer',
                    cardId: offerid,
                }

                let productCart = {
                    shipping_type: shipping_type,
                    cartId: res.data.cart_id,
                    vendorId: vendor_id
                }
                let vendortype = {
                    vendor_type: vendorStatus?.vendor_type_name
                }
                localStorage.setItem('productCart', JSON.stringify(productCart));
                localStorage.setItem('appliedCard', JSON.stringify(cardDetail));
                localStorage.setItem('shipping_type', JSON.stringify(productDetail));
                localStorage.setItem('vendortype', JSON.stringify(vendortype));


                navigate(`/ReviewPay`, { state: { flow: "offer", merchantId: vendor_id, cardStatus: '1', cardType: 'offer', cardId: offerid, inCartId: res.data.cart_id } })
            }).catch((error) => {
                console.error("Error: ", error);
            });
        } catch (error) {
            console.error("Catch Error: ", error);
        }
    }


    return (
        <div>
            <div className="d-flex justify-content-between align-items-center p-3 p-navbar bg-white">
                <div className="d-flex justify-content-between align-items-center ms-2 me-2"> <img src={p_nav_previous} width={"24px"} height={"16px"} alt="Previous Button" role="button" onClick={() => navigate(-1)} />
                    <div className="ff-balooPaaji2-bold fs-20 ms-2 ps-1">
                        {vendorStatus?.vendor_company_name}
                    </div>
                </div>
            </div>
            <div className='scroller-style-y'>
                <div>
                    {
                        categoryStatus?.service_status == 1 && vendorStatus?.service_status == '1' ?
                            <div className='px-3 py-2'>
                                <div className='p-3 BookingCard rounded-2'>
                                    <h6 className='primary-text ff-poppins-semiBold'>Book an In-store Service</h6>
                                    <p className='fs-12 ff-poppins-regular'>Browse through the service
                                        offered  in this offer  and book a service.</p>
                                    <div className='d-flex justify-content-end'>
                                        <button className='offerSelectBtn'
                                            onClick={() => { selectOfferService(1) }}>
                                            Select Service
                                        </button>
                                    </div>
                                </div>
                            </div> : <></>
                    }

                    {
                        categoryStatus?.doorstep_status == 1 && vendorStatus?.doorstep_status == '1' ?
                            <div className='px-3 py-2'>
                                <div className='p-3 BookingCard rounded-2'>
                                    <h6 className='primary-text ff-poppins-semiBold'>Book a Doorstep Service</h6>
                                    <p className='fs-12 ff-poppins-regular'>Browse through the service
                                        offered  in this offer  and book a service.
                                    </p>
                                    <div className='d-flex justify-content-end'>
                                        <button className='offerSelectBtn'
                                            onClick={() => { selectOfferService(2) }}>
                                            Select Service
                                        </button>
                                    </div>
                                </div>
                            </div>
                            : <></>
                    }


                    {categoryStatus?.product_status == 1 && vendorStatus?.vendor_type_id == '9' && vendorStatus?.dinein_product_status == '1' ?
                        <div className='px-3 py-2'>
                            <div className='p-3 BookingCard rounded-2'>
                                <h6 className='primary-text ff-poppins-semiBold'>Book a  Dine-in Product  </h6>
                                <p className='fs-12 ff-poppins-regular'>Want to enjoy this offer by dining at the restaurant ? purchase this option and redeem it by visiting the store and using our dine-in service</p>
                                <div className='d-flex justify-content-end'>
                                    <button className='offerSelectBtn'
                                        onClick={() => { setProductDetails('0'); }}>
                                        Select Product
                                    </button>
                                </div>
                            </div>
                        </div>
                        : <></>
                    }

                    {categoryStatus?.product_status == 1 && vendorStatus?.product_status == '1' ?
                        <div className='px-3 py-2'>
                            <div className='p-3 BookingCard rounded-2'>
                                <h6 className='primary-text ff-poppins-semiBold'>Book a Store Pickup Product </h6>
                                <p className='fs-12 ff-poppins-regular'>Want to pick up this offer at the store? Purchase this option and redeem it
                                    by visiting the store and doing a store pickup or store redemption </p>
                                <div className='d-flex justify-content-end'>
                                    <button className='offerSelectBtn'
                                        onClick={() => { setProductDetails(1); }}>
                                        Select Product
                                    </button>
                                </div>
                            </div>
                        </div>
                        : <></>
                    }
                    {
                        categoryStatus?.product_status == 1 && offerdetails?.delivery_status == 1 && vendorStatus?.product_delivery_status == '1' ?
                            <div className='px-3 py-2'>
                                <div className='p-3 BookingCard rounded-2'>
                                    <h6 className='primary-text ff-poppins-semiBold'>Book a Doorstep Product </h6>
                                    <p className='fs-12 ff-poppins-regular'>Get doorstep delivery of this offer? Select this option and get
                                        this item delivered at your doorsteps at an additional delivery charge </p>
                                    <div className='d-flex justify-content-end'>
                                        <button className='offerSelectBtn'
                                            onClick={() => { setProductDetails(2); }}>
                                            Select Product
                                        </button>
                                    </div>
                                </div>
                            </div>
                            :
                            <></>
                    }

                </div>
            </div>

            {
                showModal &&
                <CenterLoginNavigateModal showModal={showModal} pathname={location.pathname} onclose={() => setShowModal(false)} />
            }
        </div >
    )
}
export default OfferBooking